import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button } from "@gisce/oficina-virtual-components"
import { useTranslation } from "react-i18next"
import {
  MapsHomeWork,
  Feedback,
  PersonAdd,
  Receipt,
  QueryStats,
} from "@mui/icons-material";
import { RootState } from "@/store";
import FeatureFlag from "@/components/FeatureFlag/FeatureFlag";
import { ContractationButtons } from "../../CustomItems/ContractationButtons";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";

export const UpLg = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const Settings = useSettingsContext();
  const newCustomer = useSelector((state: RootState) => state.auth.newCustomer);
  
  const firstContractPath = `common:url.contracts.${Settings.features.displayTypes.filter(type => type !== "multipoint")[0]}.default`;

const detailsButtons = () => {
  return <>
    <Button
      variant="contained"
      onClick={() => navigate(t('common:url.invoices'))}
      startIcon={<Receipt />}
    >
      {t('common:text.invoices_title')}
    </Button>
    
    <Button
      variant="contained"
      onClick={() => navigate(t(firstContractPath))}
      startIcon={<MapsHomeWork />}
    >
      {t('common:text.contracts_title')}
    </Button>

    <ContractationButtons />

  </>
}

const openIdButtons = () => {
  return !newCustomer ?
    <>
      <Button
        variant="contained"
        onClick={() => navigate(t(firstContractPath))}
        startIcon={<MapsHomeWork />}
      >
        {t('common:text.contracts_title')}
      </Button>

      <Button
        variant="contained"
        onClick={() => navigate(t('common:url.invoices'))}
        startIcon={<Receipt />}
      >
        {t('common:text.invoices_title')}
      </Button>
    </>
  :
    <ContractationButtons />
}

return <>

    {Settings?.header?.variant === "horizontal" && <>

      {Settings?.features?.oidc && openIdButtons()}
      {!Settings?.features?.oidc && detailsButtons()}

      {Settings.features?.contact &&
        <FeatureFlag flagName="crm.case">
          <Button
            variant="contained"
            onClick={() => navigate(t('common:url.contact'))}
            startIcon={<PersonAdd />}
          >
            {t('common:text.contact_title')}
          </Button>
        </FeatureFlag>
      }

      {Settings.features?.reclamATCMenu &&
        <Button
          variant="contained"
          onClick={() => navigate(t('common:url.reclamations'))}
          startIcon={<Feedback />}
        >
          {t('common:text.reclamations_title')}
        </Button>
      }

      {Settings.features?.contactAutoReads &&
        <Button
          variant="contained"
          onClick={() => navigate(
            t('common:url.contact') + '?autolectures=true')
          }
          startIcon={<QueryStats />}
        >
          {t('common:text.send_readings_label')}
        </Button>
      }

    </>}

  </>
}